import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  isChecked: boolean;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const Checkbox = ({ onChange, isChecked, label, value, disabled }: Props) => {
  return (
    <StyledCheckbox onClick={() => onChange(value)} disabled={disabled}>
      {!isChecked ? (
        <img
          style={{
            opacity: isChecked ? 1 : 0.5,
          }}
          src={require("../../assets/images/non-checked.png")}
          alt="fill"
        />
      ) : (
        <img src={require("../../assets/images/checked.png")} alt="fill" />
      )}
      <span>{label}</span>
    </StyledCheckbox>
  );
};

const StyledCheckbox = styled.button`
  padding: 0;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  gap: 0.25rem;
  > span {
    font-family: "Poppins-Medium";
  }
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default Checkbox;
